import type { PersistMigrate, PersistedState } from 'redux-persist';

type PersistedRootState = NonNullable<PersistedState> & { sinatra?: unknown };

/**
 * The sinatra sub-slices persist themselves via `persistFactory`. A root persist that
 * also stores the tree becomes a second owner, and `autoMergeLevel2` hard-replaces
 * `sinatra.<slice>` with the root's stale copy.
 *
 * Runs on every boot because `getStoredState` reads back every stored key regardless of
 * the blacklist, so blobs written before it still carry `sinatra`.
 */
export const stripSinatraFromPersistedState: PersistMigrate = async state => {
  if (!state || !('sinatra' in state)) {
    return state;
  }

  const next = { ...(state as PersistedRootState) };
  delete next.sinatra;

  return next;
};
